import Router from "./routers";
import './Tailwind.css';
function App() {
  return <Router />;
}

export default App;
